import { Container, Graphics, Ticker } from 'pixi.js';
import { COLORS } from '../app/theme';

/**
 * A small looping gold spinner: a faint full ring with a brighter arc rotating over it. Driven by the
 * shared Pixi ticker; the tick is removed in destroy() so a scene/modal teardown leaves nothing running.
 * Centered on its own origin (0,0) — position it by the parent.
 */
export class Spinner extends Container {
  private readonly arc: Graphics;
  private readonly tick: () => void;

  constructor(radius = 30) {
    super();
    const ring = new Graphics().circle(0, 0, radius).stroke({ width: 5, color: COLORS.gold, alpha: 0.18 });
    this.arc = new Graphics().arc(0, 0, radius, 0, Math.PI * 1.45).stroke({
      width: 5,
      color: COLORS.gold,
      alpha: 0.95,
      cap: 'round',
    });
    this.addChild(ring, this.arc);

    this.tick = (): void => {
      this.arc.rotation += Ticker.shared.deltaMS * 0.006;
    };
    Ticker.shared.add(this.tick);
  }

  override destroy(options?: Parameters<Container['destroy']>[0]): void {
    Ticker.shared.remove(this.tick);
    super.destroy(options);
  }
}
